import { gql } from "@apollo/client";
export const quotation = gql`
  fragment quotation on Quotation {
    documentId
    offerId
    insurerId
    chInsurerId
    insurerName
    insurerMessages
    period
    additionalInfo
    runningYN
    sourceOfferId
    userName
    offerDate
    currencyId
    currencyCode
    details {
      offerDetailId
      insuranceAmount
      isDirectCompensation
      selected
      policyGenerationKey
      insurerMessage
    }
  }
`;
